package kz.dentalcrm.app.screens.employees.edit.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.employees.Position
import kz.dentalcrm.app.data.network.response_model.services.Service

sealed interface EditEmployeeViewEvent : ViewEvent {
    
    data class LoadInitialData(val employeeId: Int) : EditEmployeeViewEvent
    
    data class UpdateName(val value: String) : EditEmployeeViewEvent
    
    data class UpdateSurname(val value: String) : EditEmployeeViewEvent
    
    data class UpdatePatronymic(val value: String) : EditEmployeeViewEvent
    
    data class UpdatePhone(val value: String) : EditEmployeeViewEvent
    
    data class UpdateGender(val value: String) : EditEmployeeViewEvent
    
    data class UpdateBirthDate(val value: String) : EditEmployeeViewEvent
    
    data class UpdateColor(val value: String) : EditEmployeeViewEvent
    
    data class UpdatePositions(val positions: List<Position>) : EditEmployeeViewEvent
    
    data class UpdateServices(val services: List<Service>) : EditEmployeeViewEvent
    
    data class UpdateCreateAccount(val value: Boolean) : EditEmployeeViewEvent
    
    data class UpdateEmail(val value: String) : EditEmployeeViewEvent
    
    data class UpdatePassword(val value: String) : EditEmployeeViewEvent
    
    data class TogglePermission(val permission: kz.dentalcrm.app.data.network.response_model.permissions.Permission) : EditEmployeeViewEvent
    
    data object UpdateEmployee : EditEmployeeViewEvent
    
    data object DeleteEmployee : EditEmployeeViewEvent
    
    data object ResetState : EditEmployeeViewEvent
}
